import AxiosInterceptor from "../../AxiosInterceptorAlcohol";

// 환자 조회
// request data (전부 not required)
//  - pid : 환자 ID
//  - text : 조회 : 의료진코드 / 이름 / 전화번호
//  - patient-type : 환자 타입 ( DF / HR / HN / LR / LN )
//  - patient-group : 환자 그룹 ( exp / comp / tester / common )
//  - training : 진도 ( total / normal / fallsort )
//  - order : 정렬 (name / age)
//  - page : 페이지 번호
export function getPatientFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/patient',
        method: 'get',
        params: request
    })
}


// 환자 추가
export function postPatientToAlcohol(request) {
    return AxiosInterceptor({
        url: '/patient',
        method: 'post',
        data: request
    })
}


// 환자 정보 수정
// request data
//  - psctId: 처방 코드 테이블 ID
//  - name : 이름
//  - birth : 생년월일
//  - sex : 성별
//  - patientGroup : 환자군
//  - psctCode : 처방 코드
export function putPatientToAlcohol(request){
    return AxiosInterceptor({
        url: '/patient',
        method: 'put',
        data: request
    })
}


// 환자 삭제
// request data
//  - psctId : 처방코드 테이블 ID
export function deletePatientFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/patient',
        method: 'delete',
        data: request
    })
}


// 처방 코드(의료진 코드) 발번
export function getPsctCodeFromAlcohol() {
    return AxiosInterceptor({
        url: '/patient/psct-code',
        method: 'get'
    })
}

// 환자 프로필 이미지 조회
// request data
//  - pid : 환자 ID
export function getPatientProfileImageFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/patient/profile-img',
        method: 'get',
        params: request
    })
}


// 환자 서포터 정보 조회
// request data
//  - pid
export function getPatientSupporterFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/patient/supporter',
        method: 'get',
        params: request
    })
}